import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../../components/PageHeader';

function Payments() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader 
        title="Payments"
        subtitle="Payment Processing & Management"
        backButton
        onBack={() => navigate('/finance')}
        backTitle="Back to Finance"
        sticky
      />

      <main className="max-w-4xl mx-auto px-6 py-16">
        {/* Coming Soon Message */}
        <div className="bg-white rounded-lg shadow-lg p-12 text-center">
          <div className="mb-6">
            <span className="text-8xl">💳</span>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Payment Management</h2>
          <p className="text-xl text-gray-600 mb-2">Coming Soon</p>
          <p className="text-gray-500">
            Comprehensive payment processing and management features are currently in development.
          </p>
          <div className="mt-8 pt-8 border-t border-gray-200">
            <h3 className="font-semibold text-gray-700 mb-3">Planned Features:</h3>
            <ul className="text-left max-w-md mx-auto space-y-2 text-gray-600">
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                Payment tracking and reconciliation
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                Multiple payment methods (card, bank transfer, cheque)
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                Automatic invoice payment matching
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                Payment reminder automation
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                Payment history and reports
              </li>
            </ul>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Payments;
